import React from "react";

import classnames from "classnames";

function GnbMenuWrapper({ children, isSelect = false, isGnbMenu2 = false }) {
    return (
        <ul className={classnames("fl", { gnbMenu: !isGnbMenu2, gnbMenu2: isGnbMenu2, gnbselect: isSelect })}>
            {children}
        </ul>
    );
}

export default GnbMenuWrapper;
